import { BusinessDetails } from 'core/empresa/components/BusinessDetails/BusinessDetails';
import { AccountTotalsList } from 'core/cuenta/components/AccountTotalsList/AccountTotalsList';
import { AccountsTotalsContext } from 'core/cuenta/contexts/AccountsTotalsContext';
import { useContext } from 'react';
import { LinkButton } from 'shared/components';
import { Alert, Col, Container, Row } from 'react-bootstrap';

export const AccountsTotalsPage = () => {
  const { accountsTotalsData, liquidationInProcess, goToSearch } =
    useContext(AccountsTotalsContext);

  return (
    <Container>
      {accountsTotalsData && (
        <>
          <Row className="mb-3">
            <Col>
              <BusinessDetails business={accountsTotalsData.empresa} />
            </Col>
          </Row>
          <Row>
            <Col>
              <AccountTotalsList />
            </Col>
          </Row>
          {liquidationInProcess && (
            <Row>
              <Col>
                <Alert variant="warning" className="text-center">
                  La liquidación mensual está en proceso. Los saldos informados hasta la
                  fecha pueden diferir respecto a los saldos que resulten de dicha
                  liquidación.
                </Alert>
              </Col>
            </Row>
          )}
          <Row>
            <Col className="text-center">
              <LinkButton onClick={goToSearch}>Volver</LinkButton>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};
